const suffix = "ONE CAREER CLOUD";

export function setTitle(title?: string) {
  document.title = title ? `${title} - ${suffix}` : suffix;
}

export function setGaPageTitle(title?: string, pathName?: string) {
  if (title) {
    return `${title} - ${suffix}`;
  } else if (pathName && pathName.includes("/")) {
    return suffix;
  }
}

export function setNoindex() {
  const meta = document.createElement("meta");
  meta.name = "robots";
  meta.content = "noindex";
  document.head.appendChild(meta);
}
